const { ltv_controller_factory } = require('../../life_time/ltv_controller');
const main_view = {
    template: require('../../life_time/by_day/view.html'),
    controller: [
        '$scope',
        'chartFilters',
        'economics_api',
        ltv_controller_factory('premium_passes_ltv_table', 'economics.PremiumPassesLTV'),
    ],
};
export default {
    url: '/premium_passes_ltv',
    reloadOnSearch: false,
    data: {
        priority: 803,
        title: 'Premium Passes LTV',
    },
    views: {
        '': main_view,
    },
};
